import { Logo } from "@/components/Header";

export default function Footer() {
    return (
        <footer className="border-t border-[#262638] bg-[#08080C] mt-20">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 py-10 flex flex-col sm:flex-row items-center justify-between gap-6">
                <Logo />
                <p className="font-display uppercase tracking-[0.2em] text-xs text-slate-500" data-testid="footer-tagline">
                    Where the city comes to play
                </p>
                <p className="text-xs text-slate-600 font-stat">© {new Date().getFullYear()} YKPBL. All rights reserved.</p>
            </div>
        </footer>
    );
}
